import React, { Fragment } from "react";
import { Card } from "reactstrap";
import FileContent from "./FileContent";

const FileManager = () => {
  return (
    <Fragment>
      <Card style={{padding:8}}>
        <FileContent />
      </Card>
    </Fragment>
  );
};
export default FileManager;
